import { render, staticRenderFns } from "./four-oh-four-page.vue?vue&type=template&id=5bd683a1"
import script from "./four-oh-four-page.vue?vue&type=script&lang=js"
export * from "./four-oh-four-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports